import Infrastructure from "../components/pages/Infrastructure";

export default Infrastructure;
